// import React from "react";
// import Navbar from "../../Components/Navbar";
// import Header from "../../Components/Header";
// import { Container, Typography } from "@mui/material";
// import Footer from "../../Components/Footer";
// import CallToEnroll from "../../Components/CallToEnroll";
// import PageTitle from "../../Components/PageTitle";
// import NavodayaBanner from "../../assets/Navodaya.png";

// const Navodaya = () => {
//   return (
//     <>
//       <Navbar />
      
//       <PageTitle
//         title="Navodaya Coaching - Shree Mangalam School"
//         description="Join Shree Mangalam School for expert coaching for Jawahar Navodaya Vidyalaya (JNV) entrance exams. Prepare with experienced faculty and structured study material."
//         url="/navodaya"
//         keywords="navodaya coaching, JNV preparation, jawahar navodaya vidyalaya entrance, navodaya school coaching, Shree Manglam navodaya classes"
//       />

//       <Header image={NavodayaBanner} alt={"Navodaya Coaching Banner"} />

//       <Container sx={{ mb: 5, mt: 5 }}>
//         <Typography
//           variant="h5"
//           sx={{
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             fontSize: "30px",
//             letterSpacing: 1,
//             color: "#065A79",
//             fontWeight: "bold",
//           }}
//           gutterBottom
//         >
//           Jawahar Navodaya Vidyalaya
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{
//             mt: 3,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           At Shree Mangalam School, we offer a dedicated
//           coaching program for the Jawahar Navodaya Vidyalaya (JNV) Entrance
//           Examination, designed to empower rural talent with access to quality
//           education. Our mission is to help bright young students from jaipur-gudha state highway (Just on by pass) gudha gorji,
//           and surrounding areas prepare effectively for the Class 6
//           JNV selection test — a gateway to one of India’s most prestigious
//           networks of residential schools. With the guidance of experienced
//           faculty, subject-wise conceptual teaching, regular mock tests, and
//           personalized attention, we ensure that every student feels confident
//           and well-prepared. Our coaching covers all key sections of the exam:
//           Mental Ability, Arithmetic, and Language, along with full support for
//           form filling and exam readiness. We believe no dream is too big when
//           nurtured with the right mentorship and resources — through our
//           Navodaya program, we aim to create success stories that uplift the
//           entire region.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           Our Navodaya coaching program is more than just academic preparation —
//           it is a mission to turn potential into achievement. We recognize the
//           importance of the JNV entrance exam in shaping the future of children
//           from rural Jhunjhunu, and we are committed to offering a competitive
//           edge through structured, student-friendly, and goal-oriented learning.
//           In our classrooms, children are encouraged to ask questions, think
//           critically, and develop confidence in a positive and interactive
//           environment.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           What truly sets our Navodaya program apart is the supportive
//           atmosphere we create — one that fosters discipline, motivation, and
//           continuous growth. With regular doubt-clearing sessions, progress
//           tracking, and one-on-one mentorship, we closely follow each student's
//           development. Our success is not only reflected in selections but also
//           in the transformation we witness in our students' mindset, behavior,
//           and confidence. At Shree Mangalam School, we don’t
//           just prepare students for an exam — we prepare them for a promising
//           future.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           Give your child the edge they deserve. Enroll in our Navodaya Coaching
//           Program and become part of a growing success story at Shree Mangalam
//           School.
//         </Typography>
//       </Container>
//       <CallToEnroll />
//       <Footer />
//     </>
//   );
// };

// export default Navodaya;

import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { 
  Container, 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper 
} from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import PageTitle from "../../Components/PageTitle";
import NavodayaBanner from "../../assets/Navodaya.png";

const Navodaya = () => {
  const eligibilityCriteria = [
    { 
      parameter: "Age", 
      criteria: "Born between 01-05-2013 and 30-04-2015 (for 2025-26 session)",
      note: "Age relaxation for SC/ST: 1 year"
    },
    { 
      parameter: "Studying Class", 
      criteria: "Currently studying in Class 5",
      note: "Admission sought in Class 6"
    },
    { 
      parameter: "Rural Quota", 
      criteria: "At least 75% seats reserved for rural students",
      note: "Urban quota: 25%"
    },
    { 
      parameter: "Reservation", 
      criteria: "SC: 15%, ST: 7.5%, Girls: 33%",
      note: "As per government norms"
    },
    { 
      parameter: "Attempts", 
      criteria: "Only one attempt allowed",
      note: "No second chance"
    },
    { 
      parameter: "Domicile", 
      criteria: "Must be studying in same district where JNV is located",
      note: "Proof of study required"
    },
  ];

  return (
    <>
      <Navbar />
      
      <PageTitle
        title="Navodaya Coaching - Shree Mangalam School"
        description="Join Shree Mangalam School for expert coaching for Jawahar Navodaya Vidyalaya (JNV) entrance exams. Prepare with experienced faculty and structured study material."
        url="/navodaya"
        keywords="navodaya coaching, JNV preparation, jawahar navodaya vidyalaya entrance, navodaya school coaching, Shree Manglam navodaya classes"
      />

      <Header image={NavodayaBanner} alt={"Navodaya Coaching Banner"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Jawahar Navodaya Vidyalaya
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we offer a dedicated
          coaching program for the Jawahar Navodaya Vidyalaya (JNV) Entrance
          Examination, designed to empower rural talent with access to quality
          education. Our mission is to help bright young students from jaipur-gudha state highway (Just on by pass) gudha gorji,
          and surrounding areas prepare effectively for the Class 6
          JNV selection test — a gateway to one of India's most prestigious
          networks of residential schools. With the guidance of experienced
          faculty, subject-wise conceptual teaching, regular mock tests, and
          personalized attention, we ensure that every student feels confident
          and well-prepared. Our coaching covers all key sections of the exam:
          Mental Ability, Arithmetic, and Language, along with full support for
          form filling and exam readiness. We believe no dream is too big when
          nurtured with the right mentorship and resources — through our
          Navodaya program, we aim to create success stories that uplift the
          entire region.
        </Typography>

        {/* Eligibility Criteria Table Section */}
        <Box sx={{ mt: 6, mb: 4 }}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              fontSize: "26px",
              letterSpacing: 1,
              color: "#AD1C86",
              fontWeight: "bold",
              mb: 3,
            }}
          >
            JNV Entrance Exam Eligibility Criteria (Class 6)
          </Typography>
          
          <TableContainer 
            component={Paper} 
            sx={{ 
              borderRadius: 2, 
              overflow: 'hidden',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
              mb: 3,
              overflowX: "auto"
            }}
          >
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow sx={{ bgcolor: '#065A79' }}>
                  <TableCell 
                    sx={{ 
                      color: 'white', 
                      fontWeight: 'bold',
                      fontSize: '16px',
                      fontFamily: 'Montserrat, sans-serif',
                      width: '20%'
                    }}
                  >
                    Parameter
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      color: 'white', 
                      fontWeight: 'bold',
                      fontSize: '16px',
                      fontFamily: 'Montserrat, sans-serif',
                      width: '50%'
                    }}
                  >
                    Eligibility Criteria
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      color: 'white', 
                      fontWeight: 'bold',
                      fontSize: '16px',
                      fontFamily: 'Montserrat, sans-serif',
                      width: '30%'
                    }}
                  >
                    Note
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {eligibilityCriteria.map((row, index) => (
                  <TableRow 
                    key={index}
                    sx={{ 
                      
                      '&:nth-of-type(odd)': { bgcolor: '#F8F9FA' },
                      '&:hover': { bgcolor: '#F0F7FF' }
                    }}
                  >
                    <TableCell 
                      component="th" 
                      scope="row"
                      sx={{ 
                        fontWeight: 'bold',
                        fontFamily: 'Montserrat, sans-serif',
                        color: '#065A79',
                        verticalAlign: 'top'
                      }}
                    >
                      {row.parameter}
                    </TableCell>
                    <TableCell 
                      sx={{ 
                        fontFamily: 'Montserrat, sans-serif',
                        lineHeight: '1.6',
                        verticalAlign: 'top'
                      }}
                    >
                      {row.criteria}
                    </TableCell>
                    <TableCell 
                      sx={{ 
                        fontFamily: 'Montserrat, sans-serif',
                        fontStyle: 'italic',
                        color: '#666',
                        verticalAlign: 'top'
                      }}
                    >
                      {row.note}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Typography
            variant="body2"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 0.5,
              lineHeight: "1.6rem",
              color: "#555",
              p: 2,
              bgcolor: '#F8F9FA',
              borderRadius: 1,
              borderLeft: '4px solid #AD1C86'
            }}
          >
            <strong>Important:</strong> The above eligibility criteria are based on the 2024-25 admission cycle. 
            Exact dates and percentages may vary slightly each year. Students must be studying in a 
            government/recognized school in the same district where they are applying.
          </Typography>
        </Box>

        <Typography
          variant="body1"
          sx={{
            mt: 4,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our Navodaya coaching program is more than just academic preparation —
          it is a mission to turn potential into achievement. We recognize the
          importance of the JNV entrance exam in shaping the future of children
          from rural Jhunjhunu, and we are committed to offering a competitive
          edge through structured, student-friendly, and goal-oriented learning.
          In our classrooms, children are encouraged to ask questions, think
          critically, and develop confidence in a positive and interactive
          environment.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          What truly sets our Navodaya program apart is the supportive
          atmosphere we create — one that fosters discipline, motivation, and
          continuous growth. With regular doubt-clearing sessions, progress
          tracking, and one-on-one mentorship, we closely follow each student's
          development. Our success is not only reflected in selections but also
          in the transformation we witness in our students' mindset, behavior,
          and confidence. At Shree Mangalam School, we don't
          just prepare students for an exam — we prepare them for a promising
          future.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Give your child the edge they deserve. Enroll in our Navodaya Coaching
          Program and become part of a growing success story at Shree Mangalam
          School.
        </Typography>
      </Container>
      <CallToEnroll />
      <Footer />
    </>
  );
};

export default Navodaya;